import { useEffect, useState } from "react";
import "./Breadcrums.css";
import { Link, useLocation, useParams } from "react-router-dom";
import ApiService from "../../components/Api_services";

const Breadcrums = ({ productName: externalProductName }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const location = useLocation();
  // const currentFullPath = location.pathname + location.search;
  const params = new URLSearchParams(location.search);
  const filterType = params.get("filter_type");
  const currentFullPath = filterType
    ? `${location.pathname}?filter_type=${filterType}`
    : location.pathname;
  let breadcrumsContent = "breadcrums-content";

  // Find product name from fetched productData or from props
  let productName = externalProductName || "";

  if (
    currentFullPath === "/explorebrand" ||
    currentFullPath === "/exploreproduct" ||
    currentFullPath === "/productlist?filter_type=coming_soon" ||
    currentFullPath === "/productlist?filter_type=bundle" ||
    currentFullPath === "/productlist?filter_type=package" ||
    currentFullPath === "/productlist?filter_type=new_arrival" ||
    currentFullPath === "/productlist?filter_type=promotion" ||
    currentFullPath === "/preorder" ||
    currentFullPath === "/brandservicecenter" ||
    currentFullPath === "/refundreturnpolicy" ||
    currentFullPath === "/faq" ||
    currentFullPath === "/privacypolicy" ||
    currentFullPath === "/termsconditions"
  ) {
    breadcrumsContent += " type1"; // use background-color: #eee9dd;
  } else {
    breadcrumsContent += " type2"; // use background-color: #f5f5f7;
  }

  // define mapping for specialLv2Map
  const specialLv2Map = [
    {
      path: "/explorebrand",
      className: "lv2-sp",
      label: "Brands",
      title: "BRANDS",
      description: "",
    },
    {
      path: "/exploreproduct",
      className: "lv2-sp",
      label: "Products",
      title: "PRODUCTS",
      description: "",
    },
    {
      path: "/productlist?filter_type=coming_soon",
      className: "lv2-sp",
      label: "Coming Soon",
      title: "COMING SOON",
      description: "",
    },
    {
      path: "/productlist?filter_type=bundle",
      className: "lv2-sp",
      label: "Bundle",
      title: "BUNDLE",
      description: "",
    },
    {
      path: "/productlist?filter_type=package",
      className: "lv2-sp",
      label: "Package",
      title: "PACKAGE",
      description: "",
    },
    {
      path: "/productlist?filter_type=new_arrival",
      className: "lv2-sp",
      label: "New Arrivals",
      title: "NEW ARRIVALS",
      description: "",
    },
    {
      path: "/productlist?filter_type=promotion",
      className: "lv2-sp",
      label: "Promotions",
      title: "PROMOTIONS",
      description: "",
    },
    {
      path: "/preorder",
      className: "lv2-sp",
      label: "Pre-Order",
      title: "PRE-ORDER",
      description: `Pre-order now to enjoy the best price available! While you'll need to wait a little longer for delivery,
      the savings make it worth it. Reserve your spot today and get the deal you deserve!`,
    },
    {
      path: "/brandservicecenter",
      className: "lv2-sp",
      label: "Brand Service Center",
      title: "BRAND SERVICE CENTER",
      description: "",
    },
    {
      path: "/refundreturnpolicy",
      className: "lv2-sp",
      label: "Refund & Return Policy",
      title: "REFUND & RETURN POLICY",
      description: "",
    },
    {
      path: "/faq",
      className: "lv2-sp",
      label: "FAQ",
      title: "FAQ",
      description: "",
    },
    {
      path: "/privacypolicy",
      className: "lv2-sp",
      label: "Privacy Policy",
      title: "PRIVACY POLICY",
      description: "",
    },
    {
      path: "/termsconditions",
      className: "lv2-sp",
      label: "Terms & Conditions",
      title: "TERMS & CONDITIONS",
      description: "",
    },
  ];

  // lv2Map: any other location beside the one used in specialLv2Map
  const specialPaths = specialLv2Map.map((item) => item.path);
  const isSpecial = specialPaths.includes(currentFullPath);

  const lv2Map = !isSpecial
    ? [
        {
          prefix: "/mywishlist",
          label: "My Wishlist",
          isEndItem: location.pathname === "/mywishlist",
          canNavigate: true,
        },
        {
          prefix: "/myshoppingcart",
          label: "Your Shopping Cart",
          isEndItem: location.pathname === "/myshoppingcart",
          canNavigate: true,
        },
        {
          prefix: "/productdetail",
          navigateprefix: "/productlist",
          label: "Product List",
          isEndItem: false,
          canNavigate: true,
        },
        {
          prefix: "/packageproductdetail",
          navigateprefix: "/productlist",
          label: "Product List",
          isEndItem: false,
          canNavigate: true,
        },
        {
          prefix: "/grouppackagedetail",
          navigateprefix: "/productlist",
          label: "Product List",
          isEndItem: false,
          canNavigate: true,
        },
        {
          prefix: "/", // catch all other locations
          label: "Product List",
          isEndItem: true,
        },
      ]
    : [];

  // find the matching breadcrumb
  const specialLv2Item = specialLv2Map.find(
    (item) => currentFullPath === item.path,
  );

  const lv2Item = lv2Map.find((item) =>
    currentFullPath.startsWith(item.prefix),
  );

  // add dynamic lv3Item for subcategory
  let lv3Item = null;
  if (
    (location.pathname.includes("/productdetail/") && productName) ||
    (location.pathname.includes("/packageproductdetail/") && productName) ||
    (location.pathname.includes("/grouppackagedetail/") && productName)
  ) {
    lv3Item = {
      label: productName,
    };
  }

  return (
    <div className="breadcrums">
      <div className={breadcrumsContent}>
        <div className="breadcrums-margin">
          <div className="breadcrums-top">
            <div className="lv1">
              <Link to="/">Home&nbsp;/&nbsp;</Link>
            </div>

            <div className="lv2">
              {specialLv2Item && (
                <div className={specialLv2Item.className}>
                  <span>{specialLv2Item.label}</span>
                </div>
              )}
              {lv2Item &&
                (lv2Item.isEndItem ? (
                  <div className="lv2-enditem">
                    <span>{lv2Item.label}</span>
                  </div>
                ) : (
                  <div className="lv2-item">
                    {lv2Item.canNavigate === true ? (
                      <Link
                        to={
                          (location.pathname.startsWith("/productdetail") ||
                            location.pathname.startsWith(
                              "/packageproductdetail",
                            ) ||
                            location.pathname.startsWith(
                              "/grouppackagedetail",
                            )) &&
                          lv2Item.navigateprefix
                            ? lv2Item.navigateprefix
                            : lv2Item.prefix
                        }
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {lv2Item.label}&nbsp;/&nbsp;
                      </Link>
                    ) : (
                      <span>{lv2Item.label}&nbsp;/&nbsp;</span>
                    )}
                  </div>
                ))}
            </div>

            <div className="lv3">
              {lv3Item && (
                <div className="lv3-item">
                  <span>{lv3Item.label}</span>
                </div>
              )}
            </div>
          </div>

          {specialLv2Item && (
            <div className="breadcrums-bottom">
              <div className="lv2-title">{specialLv2Item.title}</div>
              <div className="lv2-description">
                {specialLv2Item.description}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Breadcrums;
